import item1 from '@/(front-desk)/assets/images/marquee/item-1.png'
import classNames from 'classnames'

const itemList = [
    {
        type: 'image',
        content: item1.src,
    },
    {
        type: 'text',
        content: '2026.5.28(四) - 5.30(六) 高雄展覽館',
    },
    {
        type: 'image',
        content: item1.src,
    },
    {
        type: 'text',
        content: '放視大賞 VISION GET WILD'
    }
]

export default function Marquee() {
    return (
        <div className="marquee" tabIndex={0}>
            <div className="marquee-content marquee-content-1">
                { Array(4).fill().map((e, listIndex) => {
                    const items = 
                        itemList.map((item, index) => {
                            if (item.type === 'text') {
                                return <div
                                            key={`${listIndex}-item-${index}`}
                                            className="text-[1.125rem] whitespace-nowrap font-bold"
                                        >{item.content}</div>
                            }
                            else if (item.type === 'image') {
                                return <img
                                            className={classNames({'star': item.name === 'star'})}
                                            key={`${listIndex}-item-${index}`}
                                            src={item.content}
                                        />
                            }
                        })
                    return items
                })}
            </div>
        </div>
    )
}